import { useAuth } from "@/context/auth-context";
import useGetPaymentCredentials from "@/features/payment-credentials/useGetPaymentCredentials";
import { Navigate, useLoaderData } from "@tanstack/react-router";
import PageLoader from "../../../../../../components/ui/PageLoader";
import SoftpointIframe from "./SoftpointIframeInner";

type SoftpointIframeDataFetcherProps = {
	companyName: string;
};

function SoftpointIframeDataFetcher({
	companyName,
}: SoftpointIframeDataFetcherProps) {
	const { location_id } = useLoaderData({ from: "__root__" });
	const paymentCredsQuery = useGetPaymentCredentials(location_id);
	const { user } = useAuth();

	if (!user.has_verified_identity) {
		return <Navigate to="/main/verify-identity" />;
	}

	return (
		<PageLoader query={paymentCredsQuery}>
			{(session) => {
				return (
					<SoftpointIframe
						user={user}
						companyName={companyName}
						iframeAccessToken={session.iframe_access_token}
						locationId={location_id}
					/>
				);
			}}
		</PageLoader>
	);
}

export default SoftpointIframeDataFetcher;
